import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { object, string } from 'yup';
import ContentRequestForm from './content_request_form';
import { post } from '../../../utils/shared/api';
import { handleSubmitError } from '../../utils/errors';
import GrapeFormat from '../../utils/formatters/formik-grape-formatter';
import Header from './header';

export default function NewContentRequestForm(props) {
  const { appData } = props;
  const { brandProfileId } = JSON.parse(appData);

  return (
    <article id="content-request-form-form">
      <Header>Create a content request form</Header>
      <Formik
        initialValues={{
          contentRequestFormId: null,
          brandProfileId,
          name: '',
          instructions: '',
          includeAudience: false,
          includePillar: false,
          file: null,
          questions: []
        }}
        validationSchema={object().shape({
          name: string().required('Name is required')
        })}
        onSubmit={(values, actions) => {
          post(
            '/api/v1/content_request_forms/',
            JSON.stringify(GrapeFormat({ ...values }, ['questions']))
          )
            .then(() => window.location.replace('./'))
            .catch(errorResponse => {
              handleSubmitError(
                errorResponse,
                actions,
                'There was an error saving your brief template.'
              );
            });
        }}
        render={innerProps => <ContentRequestForm {...innerProps} isFetching={false} />}
      />
    </article>
  );
}

NewContentRequestForm.propTypes = {
  appData: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_request_forms/new_content_request.jsx